import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Block or UNblock a channel member (owner moderation from the message user
 * card). The server TOGGLES the member doc's `blocked` flag; blocked members'
 * messages stop showing in the channel. 1:1 with PopshopRN's
 * `ToggleBlockButton` → `communityChannelApiControllerToggleMemberBlockInCommunityChannel`.
 */
export async function toggleMemberBlock({
  creatorId,
  channelId,
  memberId,
}: {
  creatorId: string;
  channelId: string;
  memberId: string;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerToggleMemberBlockInCommunityChannel({
    sellerId: creatorId,
    channelId,
    memberId,
  });
}
